export const fetch_notifications_api = "host/customer/notifications";
export const fetch_unread_notification_count_api =
  "host/customer/notification/unread/count";
export const mark_notification_read_api = "users/customer/notification/seen";
